import React from "react";
import ReactPlayer from "react-player";

export default function LovelyBgm() {
  return (
    <ReactPlayer
      url="https://watalk-bgm.s3-ap-northeast-1.amazonaws.com/Lovely_(demo).m4a"
      playing={true}
      loop={true}
      width={0}
      height={0}
    ></ReactPlayer>
  );
}
